var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "suggested-queries",
      class: {
        mobile: _vm.mobile,
        desktop: !_vm.mobile
      },
      attrs: { "data-testid": _vm.testId }
    },
    [
      _c("h4", [_vm._v("Popular searches")]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.suggestedQueries, function(query) {
          return _c(
            "li",
            {
              key: query,
              attrs: { "data-testid": _vm.testId + "_suggestion" }
            },
            [
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.updateSearchQuery(query)
                    }
                  }
                },
                [_vm._v(_vm._s(query))]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }